import React from 'react';

export default function CoverSlide({ mappingName, totalIdeas }) {
    return (
        <div className="h-full w-full flex flex-col items-center justify-center bg-[#1a1a1a] text-white p-8 relative">

            <div className="text-center max-w-4xl">
                <div className="flex items-center justify-center mb-24 text-center opacity-60">
                    <img
                        src="/images/opificioai-logo-white.png"
                        alt="OpificioAI"
                        className="h-14 md:h-18 w-auto"
                    />
                </div>

                <h1 className="text-5xl md:text-7xl font-bold mb-6 relative z-10">
                    {mappingName || 'Mappatura Aziendale'}
                </h1>

                <p className="text-xl md:text-2xl text-white/60 mb-12">
                    Analisi delle opportunità di implementazione AI
                </p>

                <div className="inline-flex items-center gap-4 bg-white/10 rounded-2xl px-8 py-4">
                    <span className="text-4xl font-bold">{totalIdeas}</span>
                    <span className="text-lg text-white/70">
                        {totalIdeas === 1 ? 'Idea Identificata' : 'Idee Identificate'}
                    </span>
                </div>
            </div>

            <div className="absolute bottom-24 left-1/2 -translate-x-1/2 text-white/30 text-sm">
                Premi → per continuare
            </div>
        </div>
    );
}
